import Requisicao from "./RequisicaoService";

class TemaService {            
    static async listar() {
        return Requisicao.get('tema');
    }

    static async buscar(id) {
        return Requisicao.get('tema/' + id);
    }
    
    static async gravar(dados) {
        return Requisicao.post('tema', dados, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static async remover(id) {        
        return Requisicao.delete('tema/' + id);
    }
}

export default TemaService;